import axios from 'axios';

const api = axios.create({
  baseURL: "https://backend.penpencilbd.com/wp-json/wc/v3/",
  headers: {
    'Authorization': `Basic ${btoa('ck_1fa6b979b52ca70f07be3760fb0540b0522d39d9' + ':' + 'cs_48a832610a53a1d3e878c43676f410ee5208493e')}`,
    'Content-Type': 'application/json',
  },
});

export default api;
